module.exports = "<md-list ng-cloak class=\"f-results-list\">\n  <f-competitor-result\n    immutable=\"list.results\"\n    array=\"true\"\n    ng-repeat=\"result in immutable track by $index\"\n    result=\"result\"\n    toggle-row=\"list.toggleRow( result )\"\n    expanded=\"list.selected.event === result.event\"\n    loading=\"list.loading\"\n    details=\"list.getDetails( result )\"\n    person=\"list.person\"\n    >\n    </f-competitor-result>\n</md-list>\n"


//////////////////
// WEBPACK FOOTER
// ./result-list/tpl.html
// module id = 1147
// module chunks = 0